import Types from './Types';

const INITIAL_STATE = {
    studentChapters: [],
    chapters: [],
    allChapters: [],
    isLoading: false,
    count: '',
    /** keyed by chapter id — loaded via GET /students/chapters/content/:id */
    chapterContentById: {},
};

export default function studentChapters(state = INITIAL_STATE, action) {
    const { type, payload } = action;
    switch (type) {
        case Types.GET_STUDENT_CHAPTERS_SUCCESS: {
            return {
                ...state,
                studentChapters: payload.data,
                count: payload.data.length
            };
        }
        case Types.GET_ALL_STUDENT_CHAPTERS_SUCCESS: {
            return {
                ...state,
                chapters: payload.data,
                count: payload.data.length
            };
        }
        case Types.GET_ALL_CHAPTERS_SUCCESS: {
            return {
                ...state,
                allChapters: payload.data,
                count: payload.data.length
            };
        }

        case Types.ADD_STUDENT_CHAPTERS_LOADING: {
            return {
                ...state,
                isLoading: payload
            };
        }

        case Types.GET_CHAPTER_CONTENT_REQUEST: {
            const id = payload;
            return {
                ...state,
                chapterContentById: {
                    ...state.chapterContentById,
                    [id]: {
                        ...(state.chapterContentById[id] || {}),
                        loading: true,
                        error: null,
                    },
                },
            };
        }
        case Types.GET_CHAPTER_CONTENT_SUCCESS: {
            const { chapterId, videos, lessons, exams, live_videos, homeworks } = payload;
            return {
                ...state,
                chapterContentById: {
                    ...state.chapterContentById,
                    [chapterId]: {
                        loading: false,
                        loaded: true,
                        error: null,
                        videos: Array.isArray(videos) ? videos : [],
                        lessons: Array.isArray(lessons) ? lessons : [],
                        exams: Array.isArray(exams) ? exams : [],
                        live_videos: Array.isArray(live_videos) ? live_videos : [],
                        homeworks: Array.isArray(homeworks) ? homeworks : [],
                    },
                },
            };
        }
        case Types.GET_CHAPTER_CONTENT_FAIL: {
            const { chapterId, error } = payload;
            return {
                ...state,
                chapterContentById: {
                    ...state.chapterContentById,
                    [chapterId]: {
                        ...(state.chapterContentById[chapterId] || {}),
                        loading: false,
                        loaded: false,
                        error: error || 'Failed to load content',
                    },
                },
            };
        }

        case Types.DELETE_VIDEO_SUCCESS: {
            const newvideos = state.videos.filter((item) => item.id !== payload);
            return {
                ...state,
                videos: newvideos
            };
        }

        default: {
            return state;
        }
    }
}
